import { EstimateStatus } from '../enums/estimate-status';
import { EstimateSettingsFilters } from '../stores/estimates-filters.store';

export const EstimatesFilterSettings: Record<EstimateStatus, keyof EstimateSettingsFilters> = {
    [EstimateStatus.Open]: 'open',
    [EstimateStatus.Sold]: 'sold',
    [EstimateStatus.Dismissed]: 'dismissed',
    [EstimateStatus.Expired]: 'expired',
};
